export default __webpack_public_path__ + "static/media/Keg of Hyrkanian Tonic.7d92169f.jpg";